import { render, staticRenderFns } from "./MlChat.vue?vue&type=template&id=51808cd5&scoped=true"
import script from "./MlChat.vue?vue&type=script&lang=js"
export * from "./MlChat.vue?vue&type=script&lang=js"
import style0 from "./MlChat.vue?vue&type=style&index=0&id=51808cd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51808cd5",
  null
  
)

export default component.exports